module.exports = __webpack_public_path__ + "static/media/006.02f08bac.jpeg";